<template>
    <div>
        <v-list-item @click.stop="dialog = true">
            <v-list-item-title>Edit</v-list-item-title>
        </v-list-item>
        <v-dialog width="700px" v-model="dialog">
            <v-card v-if="dialog">
                <v-card-title>
                    <span class="headline">Edit Shift, {{period_date | formatDate}}</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-row align="stretch">
                        <!-- right panel -->
                        <v-col cols="12">
                            <v-form ref="form">
                                <v-row>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                            class="hide-time-picker-indicator"
                                            type="time"
                                            menu-props="auto, overflowY"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-clock-outline"
                                            clearable
                                            outlined
                                            label="Start Time*"
                                            hint="Example: 08:00"
                                            required
                                            v-model="start_time"
                                            :items="timeList"
                                            item-text="name"
                                            item-value="value"
                                            :error-messages="startTimeErrors"
                                            @input="$v.start_time.$touch()"
                                            @blur="$v.start_time.$touch()"
                                            dense
                                        >
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                            class="hide-time-picker-indicator"
                                            type="time"
                                            menu-props="auto, overflowY"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-clock-outline"
                                            clearable
                                            outlined
                                            label="Finish Time*"
                                            hint="Example: 18:30"
                                            required
                                            v-model="finish_time"
                                            :items="timeList"
                                            item-text="name"
                                            item-value="value"
                                            :error-messages="finishTimeErrors"
                                            @input="$v.finish_time.$touch()"
                                            @blur="$v.finish_time.$touch()"
                                            dense
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                            prepend-icon="mdi-wallet-giftcard"
                                            label="Add Driver Bonus"
                                            item-text="name"
                                            item-value="id"
                                            v-model="cost_bonus"
                                            :items="bonus_list"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            type="number"
                                            prepend-icon="mdi-gas-station"
                                            label="Add Fuel Bonus"
                                            v-model="const_fuel_bonus"
                                            required
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            outlined
                                            label="Comment"
                                            v-model="comment"
                                        ></v-textarea>
                                    </v-col>

                                </v-row>

                                <div class="d-flex justify-center">
                                    <v-btn
                                            depressed
                                            class="mr-4 primary"
                                            :disabled="this.$v.$invalid || localLoading"
                                            :loading="localLoading"
                                            @click="submit"
                                    ><v-icon left>mdi-upload</v-icon>Save</v-btn>
                                    <v-btn
                                            class="mr-4"
                                            :loading="localLoading"
                                            depressed
                                            @click="clear"
                                    ><v-icon left>mdi-rotate-left</v-icon><span class="hidden-sm-and-down">Restore</span></v-btn>
                                    <v-btn
                                            class="mr-4 warning"
                                            :loading="localLoading"
                                            depressed
                                            @click="dialog=false"
                                    ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                                </div>

                            </v-form>
                        </v-col>
                        <!--/ right panel -->
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import moment from 'moment';

export default {
    mixins: [validationMixin],
    name: "EditShiftModal",
    props: ['shiftItem' /*, 'restaurantItem'*/],
    validations: {
        // driver_id: { required },
        start_time: { required,/* maxLength: maxLength(10)*/ },
        finish_time: { required },
        comment: { }
    },
    data: () => ({
        /*valid: false,*/
        readOnly: false,
        localLoading: false,
        dialog: false,
        // --
        // restaurant_id: '',
        // driver_id: 0,
        // status: '10',
        period_date: '',
        start_time: '',
        finish_time: '',
        cost_per_hour: '',
        cost_total: '',
        cost_bonus: 0,
        const_fuel_bonus: 0,
        cost_extra_bonus: 0,
        comment: '',
        // --
        // restaurant_selected: void 0,
        area_selected: void 0,
        is_initialized: false,
        bonus_list: [
            {id: 0, name: 'no bonus'},
            {id: 10, name: '+£10'},
            {id: 20, name: '+£20'},
        ],
    }),
    updated() {
        if (this.$data.dialog && !this.$data.is_initialized) {

            // this.$data.restaurant_id = this.$props.shiftItem.restaurant_id;
            // this.$data.driver_id = +this.$props.shiftItem.driver_id; // "driver_id === null" become 0
            // status;
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            // this.$data.cost_per_hour = 0; //?
            // this.$data.cost_total = 0; //?
            this.$data.cost_bonus = +parseFloat(this.$props.shiftItem.cost_bonus);
            this.$data.const_fuel_bonus = +parseFloat(this.$props.shiftItem.const_fuel_bonus);
            this.$data.cost_extra_bonus = +parseFloat(this.$props.shiftItem.cost_extra_bonus);
            this.$data.comment = this.$props.shiftItem.comment;
            // created_at;
            // updated_at;

            this.$data.is_initialized = true;
        }
    },
    computed: {
        ...mapGetters(['timeList']),
        startTimeErrors () {
            const errors = [];
            if (!this.$v.start_time.$dirty) {
                return errors;
            }
            !this.$v.start_time.required && errors.push('Start Time is required.')
            !moment(this.$data.start_time, "HH:mm").isValid() && errors.push('Start Time invalid format.')
            return errors
        },
        finishTimeErrors () {
            const errors = [];
            if (!this.$v.finish_time.$dirty) {
                return errors;
            }
            !this.$v.finish_time.required && errors.push('Start Time is required.')
            !moment(this.$data.finish_time, "HH:mm").isValid() && errors.push('Finish Time invalid format.')
            return errors
        },
        contactNameErrors () {
            const errors = [];
            if (!this.$v.contactName.$dirty) {
                return errors;
            }
            !this.$v.contactName.required && errors.push('Contact Name is required.');
            return errors
        },
        /**
         * calculate Shift Length
         * result: (finish_time - start_time)
         */
        shiftLength: function() {
            let finish_time = moment(this.$data.finish_time, "HH:mm");
            let start_time = moment(this.$data.start_time, "HH:mm");
            if (!finish_time.isValid() || !start_time.isValid()) {
                return 0;
            }

            if (this.$data.finish_time < this.$data.start_time) {
                finish_time.add(1, 'days');
            }

            let total_time_hours = ( (finish_time - start_time) / (60 * 1000) ) / 60;

            return total_time_hours.toFixed(2); // round
        },
    },

    methods: {
        submit () {
            this.localLoading = true;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                const shift_data = {
                    id: this.$props.shiftItem.id,
                    // restaurant_id: this.$data.restaurant_id,
                    // driver_id: this.$data.driver_id,
                    // status: void 0,
                    period_date: this.$data.period_date,
                    start_time: this.$data.start_time,
                    finish_time: this.$data.finish_time,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: 0, //?
                    cost_total: 0, //?
                    cost_bonus: this.$data.cost_bonus,
                    const_fuel_bonus: this.$data.const_fuel_bonus,
                    cost_extra_bonus: this.$data.cost_extra_bonus,
                    comment: this.$data.comment,
                    // created_at: void 0,
                    // updated_at: void 0,
                };

                // if (shift_data.driver_id == 0) { // fix 0 to null
                //     shift_data.driver_id = null;
                // }

                this.$store.dispatch('editFreeShift', shift_data).then(() => {
                    this.dialog = false;
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        clear () {
            this.$v.$reset();
            // this.$data.restaurant_id = this.$props.shiftItem.restaurant_id;
            // this.$data.driver_id = this.$props.shiftItem.driver_id;
            // status;
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.cost_per_hour = this.$props.shiftItem.cost_per_hour;
            this.$data.cost_total = this.$props.shiftItem.cost_total;
            this.$data.cost_bonus = +this.$props.shiftItem.cost_bonus;
            this.$data.const_fuel_bonus = +this.$props.shiftItem.const_fuel_bonus;
            this.$data.cost_extra_bonus = +this.$props.shiftItem.cost_extra_bonus;
            this.$data.comment = this.$props.shiftItem.comment;
        },
    },
    filters: {
      formatDate: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
    },
}
</script>

<style scoped>

</style>
